import { useEffect } from 'react'

import { useLocation, useNavigate } from 'react-router-dom'

import { useAuth } from '@/hooks/useAuth'

const BiometricLockGuard: React.FC = () => {
  const { isLocked } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (isLocked && !location.pathname.startsWith('/auth')) {
      navigate('/auth', { replace: true, state: { from: location } })
    }
  }, [isLocked, location, navigate])

  return null
}

export default BiometricLockGuard
